import loginTemplate from './oauthlogin/oauthlogin.pug';
import oauthTemplate from './oauthauthorize/oauthauthorize.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('oauthlogin', {
    url: '/oauthlogin?client_id&redirect_uri&response_type&scope&state',
    template: loginTemplate,
    controller: 'OauthLoginController',
    controllerAs: 'vm'
  })
    .state('oauthauthorize', {
      url: '/oauthauthorize?code&client_id&redirect_uri&response_type&scope&state&email&fname', // eslint-disable-line max-len
      template: oauthTemplate,
      controller: 'OauthAuthorizeController',
      controllerAs: 'vm'
    });
}];
